import { inject } from "@angular/core";
import { CanActivateFn } from "@angular/router";

import { LocaleService } from "../../services/locale.service";
import { ActivityIndicatorService } from "../../../core-ui/services/activity-indicator.service";

export const localeGuard: CanActivateFn = async (): Promise<boolean> => {
  const locale = inject(LocaleService);
  const activity = inject(ActivityIndicatorService);

  activity.loading(true);
  try {
    await locale.loadInstanceTranslationsForLocale();
  } catch (ex) {
  } finally {
    activity.loading(false);
  }
  return true;
};
